import { ColorGenerator } from '@bringg/react-components';

/**
 * Builds the full palette of route colors by cycling through
 * `ColorGenerator.getRandomColor()` until it wraps back to the first color.
 */
export const buildColorPalette = (): string[] => {
	const getColor = ColorGenerator.getRandomColor();
	const colors = [getColor()];

	while (true) {
		const nextColor = getColor();

		if (nextColor === colors[0]) {
			break;
		}

		colors.push(nextColor);
	}

	return colors;
};
